import { render } from "./class-center.vue?vue&type=template&id=0dc647ea"
import script from "./class-center.vue?vue&type=script&lang=js"
export * from "./class-center.vue?vue&type=script&lang=js"

import "./class-center.vue?vue&type=style&index=0&id=0dc647ea&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__